import Cookies from 'js-cookie';
import moment from 'moment';
import { getRootDomain } from './get-domain';
export const set = (key, value, {
  domain = getRootDomain(),
  path = '/',
  secondsToExpire = 0,
  secure = true
} = {}) => {
  Cookies.set(key, value, {
    expires: secondsToExpire ? moment().add(secondsToExpire, 's').toDate() : null,
    domain,
    path,
    secure
  });
};
export const get = key => Cookies.get(key);
export const getJSON = key => Cookies.getJSON(key);
export const remove = (key, {
  domain = getRootDomain(),
  path = '/'
} = {}) => Cookies.remove(key, {
  domain,
  path
});
//# sourceMappingURL=cookies.js.map